import React from 'react'

export const WAVES_BIG_TEXT = (
  <>
    Наша цель — сделать Калининградскую область лидером в IT наравне с
    Иннополисом и Сколково. В 2024 году мы провели первый в регионе бесплатный
    IT-фестиваль с топовыми спикерами, нетворкингом и участием представителей
    бигтеха. <br /> <br />{' '}
    <a href="kodewaves.ru" target="_blank">
      KODE Waves
    </a>{' '}
    — первый IT-фестиваль в Калининграде, который объединяет бизнес, государство
    и IT-комьюнити. Вместе с Министерством цифровых технологий и связи, и АНО
    Цифровое развитие, мы проводим ежегодной фестиваль, где эксперты со всей
    страны делятся своим опытом, новейшими технологиями в мобильной разработке и
    поднимают темы соф-скиллов.
  </>
)
